import {Component, input} from '@angular/core';
import {SvgSpriteIcon} from '@selpia/shared/ui';

@Component({
  selector: 'lib-insight-button',
  template: `
    <button [attr.aria-label]="label()">
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32">
        <use [attr.xlink:href]="icon()"></use>
      </svg>
    </button>`,
  styleUrl: './insight-button.component.scss',
})
export class InsightButtonComponent {
  icon = input.required<SvgSpriteIcon>();
  label = input.required<string>();
}
